import { DayOfWeek } from '../enums/time.enum';
import { TimeUtil } from './time-util';

export class DateBuilder {
    private date: Date;
    constructor(date: Date) {
        // making copy instead of assigning given date
        this.date = new Date(date.getTime());
    }

    static now(): DateBuilder {
        return new DateBuilder(new Date());
    }

    addDays(days: number): DateBuilder {
        this.date.setTime(this.date.getTime() + TimeUtil.getMillisecondsFromDays(days));

        return this;
    }

    addHours(hours: number): DateBuilder {
        this.date.setTime(this.date.getTime() + TimeUtil.getMillisecondsFromHours(hours));

        return this;
    }

    addMinutes(minutes: number): DateBuilder {
        this.date.setTime(this.date.getTime() + TimeUtil.getMillisecondsFromMinutes(minutes));

        return this;
    }

    addSeconds(seconds: number): DateBuilder {
        this.date.setTime(this.date.getTime() + TimeUtil.getMillisecondsFromSeconds(seconds));

        return this;
    }

    truncateSeconds() {
        this.date.setSeconds(0, 0);

        return this;
    }

    getDate(): Date {
        return this.date;
    }

    addHoursSkippingWeekends(hours: number): DateBuilder {
        if (this.date.getDay() == DayOfWeek.SATURDAY) {
            this.setTimeStartOfDay();
            this.addDays(2);
        } else if (this.date.getDay() == DayOfWeek.SUNDAY) {
            this.setTimeStartOfDay();
            this.addDays(1);
        } else {
            hours += this.date.getHours();
            this.date.setHours(0);
        }

        let daysBeforeDeparture = Math.trunc(hours / 24);
        let remainingHoursFromDays = hours - 24 * daysBeforeDeparture;

        while (daysBeforeDeparture > 0) {
            this.addDays(1);
            let currentDay = this.date.getDay();
            if (DayOfWeek.SATURDAY != currentDay && DayOfWeek.SUNDAY != currentDay) {
                daysBeforeDeparture--;
            }
        }
        this.addHours(remainingHoursFromDays);

        return this;
    }

    setTimeStartOfDay(): DateBuilder {
        this.date.setHours(0, 0, 0, 0);

        return this;
    }
}
